import api from './api';

/**
 * Get current user settings
 */
export const getSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

/**
 * Update user settings
 */
export const updateSettings = async (settings) => {
  const response = await api.put('/settings', settings);
  return response.data;
};

/**
 * Upload logo for watermarking
 */
export const uploadLogo = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/settings/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

/**
 * Delete logo
 */
export const deleteLogo = async () => {
  const response = await api.delete('/settings/logo');
  return response.data;
};

/**
 * Generate story previews for a vehicle
 */
export const getStoryPreviews = async (vehicleId, template = null) => {
  const data = { vehicle_id: vehicleId };
  if (template) {
    data.template = template;
  }
  const response = await api.post('/publications/preview-story', data);
  return response.data;
};

/**
 * Generate a test story preview with custom settings
 */
export const getTestStoryPreview = async (settings) => {
  const params = new URLSearchParams();
  params.append('template', settings.template || 'immersive');
  if (settings.bgColor) params.append('bg_color', settings.bgColor);
  if (settings.textColor) params.append('text_color', settings.textColor);
  if (settings.accentColor) params.append('accent_color', settings.accentColor);
  if (settings.fontStyle) params.append('font_style', settings.fontStyle);
  if (settings.catchphrase) params.append('catchphrase', settings.catchphrase);
  if (settings.badge) params.append('badge', settings.badge);

  const response = await api.post(`/settings/story-preview?${params.toString()}`);
  return response.data;
};

const settingsApi = {
  getSettings,
  updateSettings,
  uploadLogo,
  deleteLogo,
  getStoryPreviews,
  getTestStoryPreview
};

export default settingsApi;
